import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted, ref } from 'vue'
import { surveyStore } from '@/stores/survey'
import axios from 'axios'
import SurveyRelationsRow from '@/components/survey/SurveyRelationsRow.vue'
import { Levels } from '@/helpers/globalVariables'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyRelationsCard',
  setup(__props) {

const loading = ref({ blocks: false, buildings: false })
const blocks = ref([])
const buildings = ref([])

onMounted(() => {
  surveyStore().survey.project.configurator_version === 1 ? getBlocks() : getBuildingGroupBlocks()

  if (surveyStore().survey.building_block_id || surveyStore().survey.building_group_block_id) {
    getBuildings()
  }
})

function getBlocks () : void {
  loading.value.blocks = true
  axios.get(process.env.VUE_APP_API_URL + '/buildingblocks?filter[project_id]=' + surveyStore().survey.project_id).then((r) => {
    blocks.value = r.data.data
  }).finally(() => {
    loading.value.blocks = false
  })
}

function getBuildingGroupBlocks () : void {
  loading.value.blocks = true
  axios.get(process.env.VUE_APP_API_URL + '/v2/buildingGroups?filter[project_id]=' + surveyStore().survey.project_id + '&filter[type]=block').then((r) => {
    blocks.value = r.data.data
  }).finally(() => {
    loading.value.blocks = false
  })
}

function getBuildings () : void {
  loading.value.buildings = true
  const blockKey = surveyStore().survey.project.configurator_version === 1 ? 'buildingblock_id' : 'building_group_block_id'
  const blockId = surveyStore().survey.project.configurator_version === 1 ? surveyStore().survey.building_block_id : surveyStore().survey.building_group_block_id
  axios.get(process.env.VUE_APP_API_URL + '/buildings?filter[' + blockKey + ']=' + blockId).then((r) => {
    buildings.value = r.data.data
  }).finally(() => {
    loading.value.buildings = false
  })
}

function updateSurvey (field:string, value:string|number|null) : void {
  axios.patch(process.env.VUE_APP_API_URL + '/surveys/' + surveyStore().survey.id, { [field]: value }).then((r) => {
    surveyStore().survey = r.data.data
    if (field === 'building_block_id' || field === 'building_group_block_id') {
      updateSurvey('building_id', null)
      updateSurvey('floor', null)
      if (value) {
        getBuildings()
      } else {
        buildings.value = []
      }
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Koppelingen",
    bordered: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { class: "no-mb" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 12}
          }, {
            default: _withCtx(() => [
              (_unref(surveyStore)().survey.project.configurator_version === 1)
                ? (_openBlock(), _createBlock(SurveyRelationsRow, {
                    key: 0,
                    label: "Blok",
                    loading: loading.value.blocks,
                    items: blocks.value,
                    "field-names": { label: 'name', value: 'id' },
                    "current-value": _unref(surveyStore)().survey.building_block_id,
                    onValueChanged: _cache[0] || (_cache[0] = ($event: any) => (updateSurvey('building_block_id', $event)))
                  }, null, 8, ["loading", "items", "current-value"]))
                : (_openBlock(), _createBlock(SurveyRelationsRow, {
                    key: 1,
                    label: "Blok",
                    loading: loading.value.blocks,
                    items: blocks.value,
                    "field-names": { label: 'name', value: 'id' },
                    "current-value": _unref(surveyStore)().survey.building_group_block_id,
                    onValueChanged: _cache[1] || (_cache[1] = ($event: any) => (updateSurvey('building_group_block_id', $event)))
                  }, null, 8, ["loading", "items", "current-value"])),
              (_unref(surveyStore)().survey.building_block_id || _unref(surveyStore)().survey.building_group_block_id)
                ? (_openBlock(), _createBlock(SurveyRelationsRow, {
                    key: 2,
                    label: "Bouwnummer",
                    loading: loading.value.buildings,
                    items: buildings.value,
                    "field-names": { labelPrefix: 'Bouwnummer ', label: 'number', value: 'id' },
                    "current-value": _unref(surveyStore)().survey.building_id,
                    onValueChanged: _cache[2] || (_cache[2] = ($event: any) => (updateSurvey('building_id', $event)))
                  }, null, 8, ["loading", "items", "current-value"]))
                : _createCommentVNode("", true),
              (_unref(surveyStore)().survey.building_block_id || _unref(surveyStore)().survey.building_group_block_id)
                ? (_openBlock(), _createBlock(SurveyRelationsRow, {
                    key: 3,
                    label: "Verdieping",
                    items: _unref(Levels),
                    "field-names": { label: 'name', value: 'id' },
                    "current-value": _unref(surveyStore)().survey.floor,
                    onValueChanged: _cache[3] || (_cache[3] = ($event: any) => (updateSurvey('floor', $event)))
                  }, null, 8, ["items", "current-value"]))
                : _createCommentVNode("", true),
              _createVNode(SurveyRelationsRow, {
                type: "text",
                label: "Locatie",
                items: _unref(Levels),
                "current-value": _unref(surveyStore)().survey.location,
                onValueChanged: _cache[4] || (_cache[4] = ($event: any) => (updateSurvey('location', $event)))
              }, null, 8, ["items", "current-value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})